import api_config from "../../../api/config/_config";
import api_caisse from "../../../api/comptabilite/_comptes";

const state = () => ({
    liste_source_depense: [],
    ligne_budgetaire_caisse: [],
    ligne_budgetaire_tresorerie: [],
    liste_all_ligne_budgetaire: [],
    liste_ligne_budgetaire_by_role: [],
    cumul_depense_ligne_budgetaire: 0,

    dotation_historique: [],

    liste_personnel_roles: [],
    info_clinique_active: [],
    countdown_info: {}
});

// getters
const getters = {
    liste_source_depense: (state) => {
        return state.liste_source_depense;
    },

    ligne_budgetaire_caisse: (state) => {
        return state.ligne_budgetaire_caisse;
    },

    ligne_budgetaire_tresorerie: (state) => {
        return state.ligne_budgetaire_tresorerie;
    },

    liste_all_ligne_budgetaire: (state) => {
        return state.liste_all_ligne_budgetaire;
    },

    liste_ligne_budgetaire_by_role: (state) => {
        return state.liste_ligne_budgetaire_by_role;
    },

    cumul_depense_ligne_budgetaire: (state) => {
        return state.cumul_depense_ligne_budgetaire;
    },

    dotation_historique: (state) => {
        return state.dotation_historique;
    },
    
    liste_personnel_roles: (state) => {
        return state.liste_personnel_roles
    },

    info_clinique_active: (state) => {
        return state.info_clinique_active
    },

    countdown_info: (state) => {
        return state.countdown_info;
    },
};
// mutations
const mutations = {
    SET_LISTE_SOURCE_DEPENSE(state, source) {
        state.liste_source_depense = source;
    },

    SET_LIGNE_BUDGETAIRE_CAISSE(state, liste) {
        state.ligne_budgetaire_caisse = liste;
    },

    SET_LIGNE_BUDGETAIRE_TRESORERIE(state, liste) {
        state.ligne_budgetaire_tresorerie = liste;
    },

    SET_LISTE_ALL_LIGNE_BUDGETAIRE(state, liste) {
        state.liste_all_ligne_budgetaire = liste;
    },

    SET_LISTE_LIGNE_BUDGETAIRE_BY_ROLE(state, liste) {
        state.liste_ligne_budgetaire_by_role = liste;
    },

    SET_CUMUL_DEPENSE_LIGNE_BUDGETAIRE(state, liste) {
        state.cumul_depense_ligne_budgetaire = liste;
    },

    SET_DOTATION_HISTORIQUE(state, liste) {
        state.dotation_historique = liste;
    },

    SET_ACCES_PERSONNEL_ROLE(state, personnel) {
        state.liste_personnel_roles = personnel;
    },

    SET_INFO_CLINIQUE_ACTIVE(state, info) {
        state.info_clinique_active = info;
    },

    SET_COUNTDOWN_INFO(state, countdown) {
        state.countdown_info = countdown
    },
};

// actions
const actions = {
    getListeSourceDepense({ commit }) {
        return new Promise((resolve, reject) => {
            api_config.getListeSourceDepense().then(
                (response) => {
                    commit("SET_LISTE_SOURCE_DEPENSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    // +++++++++++++++++   LIGNE BUDGETAIRE   +++++++++++++++++++

    /** */
    saveSourceDepense({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api_caisse.saveSourceDepense(data).then(
                (response) => {
                    dispatch("getListeSourceDepense");
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDotation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api_caisse.getDotation(data).then(
                (response) => {
                    if (data.role_id == 4) {
                        commit("SET_LIGNE_BUDGETAIRE_CAISSE", response);
                    } else if (data.role_id == 14) {
                        commit("SET_LIGNE_BUDGETAIRE_TRESORERIE", response);
                    }
                    commit("SET_LISTE_LIGNE_BUDGETAIRE_BY_ROLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getLigneBudgetaire({ commit }, role_id) {
        return new Promise((resolve, reject) => {
            api_caisse.getLigneBudgetaire(role_id).then(
                (response) => {
                    if (role_id == 4) {
                        commit("SET_LIGNE_BUDGETAIRE_CAISSE", response);
                    } else if (role_id == 14) {
                        commit("SET_LIGNE_BUDGETAIRE_TRESORERIE", response);
                    }
                    commit("SET_LISTE_LIGNE_BUDGETAIRE_BY_ROLE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteLigneBudgetaire({ commit }, data) {
        return new Promise((resolve, reject) => {
            api_caisse.deleteLigneBudgetaire(data).then(
                (response) => {
                    if (data.role_id == 4) {
                        commit("SET_LIGNE_BUDGETAIRE_CAISSE", response);
                    } else if (data.role_id == 14) {
                        commit("SET_LIGNE_BUDGETAIRE_TRESORERIE", response);
                    }
                    
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAllLigneBudgetaire({ commit }) {
        return new Promise((resolve, reject) => {
            api_caisse.getAllLigneBudgetaire().then(
                (response) => {
                    commit("SET_LISTE_ALL_LIGNE_BUDGETAIRE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSommeLigneBudgetaire({ commit }, ligne_budgetaire) {
        return new Promise((resolve, reject) => {
            api_caisse.getSommeLigneBudgetaire(ligne_budgetaire).then(
                (response) => {
                    commit("SET_CUMUL_DEPENSE_LIGNE_BUDGETAIRE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveDotation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api_caisse.saveDotation(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteDotation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api_caisse.deleteDotation(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getHistoriqueDotation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api_caisse.getHistoriqueDotation(data).then(
                (response) => {
                    commit("SET_DOTATION_HISTORIQUE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    updateUserProfil({dispatch}, data){
        return new Promise((resolve,reject) => {
            api_config.updateUserProfil(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    updateUserPassword({dispatch}, data){
        return new Promise((resolve,reject) => {
            api_config.updateUserPassword(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getRolePersonnels({commit}) {
        return new Promise((resolve, reject) => {
            api_config.getRolePersonnels().then(
                response => {
                    resolve(response)
                    commit('SET_ACCES_PERSONNEL_ROLE', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getInfoCliniqueActive({commit}) {
        return new Promise((resolve, reject) => {
            api_config.getInfoCliniqueActive().then(
                response => {
                    resolve(response)
                    commit('SET_INFO_CLINIQUE_ACTIVE', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteItem({dispatch}, data) {
        return new Promise((resolve,reject) => {
            api_caisse.deleteItem(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getCountDown({ commit }) {
        return new Promise((resolve, reject) => {
            api_config.getCountDown().then((response) => {
                commit("SET_COUNTDOWN_INFO", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};